import { Controller } from '@hotwired/stimulus'

export default class extends Controller {
  static targets = ['mainImage', 'thumbnail']

  connect () {
    // Устанавливаем первое изображение как активное
    this.setActiveThumbnail(0)
  }

  changeImage (event) {
    const clickedThumbnail = event.currentTarget
    const newImageUrl = clickedThumbnail.dataset.imageUrl
    const index = parseInt(clickedThumbnail.dataset.index)

    // Меняем главное изображение
    this.mainImageTarget.src = newImageUrl

    // Обновляем активную миниатюру
    this.setActiveThumbnail(index)
  }

  setActiveThumbnail (activeIndex) {
    this.thumbnailTargets.forEach((thumbnail, index) => {
      const img = thumbnail.querySelector('img')
      if (index === activeIndex) {
        img.classList.remove('opacity-70')
        img.classList.add('opacity-100', 'ring-2', 'ring-blue-500')
      } else {
        img.classList.remove('opacity-100', 'ring-2', 'ring-blue-500')
        img.classList.add('opacity-70')
      }
    })
  }
}
